/* WishesVerse Publisher Pro V2: progressively enhanced, no article text hidden. */
(() => {
  const init = (root) => {
    if (!root || root.dataset.wvV2Ready === '1') return;
    root.dataset.wvV2Ready = '1';
    const content = root.querySelector('#wv-article-content');
    if (!content) return;
    const toc = root.querySelector('[data-wv-toc]');
    const details = root.querySelector('[data-wv-toc-details]');
    if (toc) {
      const headings = [...content.querySelectorAll('h2')];
      if (headings.length > 1) {
        const list = document.createElement('ol'); list.className = 'wv-toc-list';
        const seen = new Set([...document.querySelectorAll('[id]')].map(x => x.id));
        headings.forEach((h, index) => {
          if (!h.id) {
            let id = 'wv-heading-' + (index + 1);
            let n = 2; while (seen.has(id)) id = 'wv-heading-' + (index + 1) + '-' + n++;
            h.id = id; seen.add(id);
          }
          const li = document.createElement('li'); const a = document.createElement('a');
          a.href = '#' + encodeURIComponent(h.id); a.textContent = h.textContent.trim();
          li.append(a); list.append(li);
        }); toc.replaceChildren(list);
      } else if (details) { details.hidden = true; }
    }
    if (details && window.matchMedia('(max-width: 990px)').matches) details.open = false;
    const cards = content.querySelectorAll('blockquote, .wv-quote-card, .quote-card, .message-card, .prayer-card');
    cards.forEach(card => {
      if (card.querySelector('.wv-inline-copy')) return;
      const button = document.createElement('button'); button.type = 'button'; button.className = 'wv-inline-copy';
      button.textContent = 'Copy text'; button.setAttribute('aria-label', 'Copy this quote or message');
      button.addEventListener('click', async () => {
        const clone = card.cloneNode(true); clone.querySelectorAll('button,script,style').forEach(el => el.remove());
        const value = clone.innerText?.trim() || clone.textContent.trim();
        if (!value) return;
        try {
          if (navigator.clipboard && window.isSecureContext) await navigator.clipboard.writeText(value);
          else { const tmp=document.createElement('textarea');tmp.value=value;tmp.style.position='fixed';tmp.style.opacity='0';document.body.append(tmp);tmp.select();if(!document.execCommand('copy')) throw new Error('Copy blocked');tmp.remove(); }
          button.textContent = 'Copied!';
        } catch (_) { button.textContent = 'Select text to copy'; }
        window.setTimeout(() => { button.textContent = 'Copy text'; }, 2000);
      }); card.append(button);
    });
    content.querySelectorAll('table').forEach(t => {
      if (t.parentElement?.classList.contains('wv-table-scroll')) return;
      const wrapper = document.createElement('div'); wrapper.className = 'wv-table-scroll';wrapper.setAttribute('role','region'); wrapper.setAttribute('aria-label','Scrollable article table');wrapper.tabIndex=0;
      t.parentNode.insertBefore(wrapper,t);wrapper.append(t);
    });
  };
  const run = () => document.querySelectorAll('[data-wv-article]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',run,{once:true}); else run();
  document.addEventListener('shopify:section:load',run);
})();
